import { FaBuilding } from 'react-icons/fa'
import { Sidebar } from 'components/ideal-core-ui'
import { CompanyInfoSection } from 'components/common/CompanyInfoSection'
import s from '../Contact.scss'

const ContactSidebar = ({ company, companyDeals, companyPipeline }) => {
  return (
    <Sidebar
      className="sidebar-global"
      title={
        <div className={s.sidebarTitle}>
          <FaBuilding />
          Company Information
        </div>
      }
      sidebarType="contactSidebar"
      sections={[
        {
          content: (
            <CompanyInfoSection
              key="0"
              company={company}
              companyDeals={companyDeals}
              companyPipeline={companyPipeline}
            />
          )
        }
      ]}
    />
  )
}

export default ContactSidebar
